import React from 'react';

const busySplashHtml = `
<div class="new-quote-container centered">
  <div class="splash-icon">⏳</div>
  <div class="splash-header">
    <h1>Your time matters.</h1>
    <div class="quote">
      We don’t expect you to make fitness your full time job. We’ll find a suitable training plan that works with your schedule and goals.
    </div>
  </div>
</div> 
`;

const busySplashElement = {
  name: 'busy-splash',
  type: 'html',
  html: busySplashHtml,
}

const BusySplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A", 
      fontSize: "12px",
    }}>
      📝 Finalizing your details
    </div>
  )
}
export {
  busySplashElement,
  BusySplashHeader
}
